import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
};

const TrsExemptionDeclarationModal: React.FC<Props> = ({ open, onCancel, onOk }) => {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="md">
      <DialogTitle>Exemption Declaration</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography>
            The TRS requires all trusts formed within the UK to register regardless of their UK tax liabilities, unless they are defined by HMRC as exempt.
          </Typography>
          <Typography>
            A Trust must be registered with the Trust Registration Service (TRS) if it becomes liable for UK tax. All UK express trusts, unless they are specifically excluded, and non-UK express trusts must also register with the Trust Registration Service (TRS), even if they have no UK tax liability. A Non-UK resident trusts must also register if it becomes liable for tax on UK assets or on income coming from the UK.
          </Typography>
          <Typography>
            I understand that assessment of the TRS registration requirements and any subsequent obligation to register is the responsibility of the Trust
          </Typography>
          <Typography>
            I confirm that the information relating to the registration requirements of the Trust is accurate.
          </Typography>
          <Typography>
            I commit to inform and update of any change to the requirement to register along with evidence of registration, without delay, and at latest within 90 days of the requirement to register arising.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button variant="outlined" onClick={onCancel}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={onOk}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrsExemptionDeclarationModal;
